var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Inicio'),_c('ProductSection'),_c('Welcome'),_c('Footer'),_c('Whatsapp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }